import React from "react";
import { motion } from "framer-motion";
import { Star, Infinity, RefreshCw, Sparkles } from "lucide-react";

const features = [
  {
    title: "Premium Quality",
    description: "Crafted with elite materials for unmatched durability.",
    icon: <Star size={36} className="text-yellow-500" />,
  },
  {
    title: "Everlasting Trend",
    description: "Timeless style that defies fleeting fads.",
    icon: <Infinity size={36} className="text-cyan-500" />,
  },
  {
    title: "Easy Exchange",
    description: "Seamless swaps, zero stress.",
    icon: <RefreshCw size={36} className="text-green-500" />,
  },
  {
    title: "Unique Edge",
    description: "One-of-a-kind designs that stand apart.",
    icon: <Sparkles size={36} className="text-pink-500" />,
  },
];

const FeaturesSection = () => {
  return (
    <section className="bg-primary dark:bg-primary-dark text-primary-text dark:text-primary-text-dark py-12 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-5xl font-extrabold mb-10 md:mb-12 text-center tracking-tight"
        >
          Why Laynered?
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2, ease: "easeOut" }}
              whileHover={{ scale: 1.03, transition: { duration: 0.2 } }}
              className="bg-primary dark:bg-primary-dark border border-neutral-800 rounded-2xl p-6 shadow-md hover:shadow-xl hover:border-neutral-700 transition-all duration-300 flex flex-col items-center text-center"
            >
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-lg md:text-xl font-semibold mb-2 text-primary-text dark:text-primary-text-dark">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-neutral-400 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;